
export class CartFlowStages {
	static readonly PRODUCTS = 'products';
	static readonly CHECKOUT = 'checkout';
	static readonly PAYMENT = 'payment';
	static readonly CONFIRMATION = 'confirmation';
}
